import React from 'react'
import "./scrollup.css"

const Scrollup = () => {
  window.addEventListener("scroll", function () {
    const scrollUp = this.document.querySelector(".scrollup");
    //add show-scroll class if scroll is greater than 560 viewport
    if (this.scrollY >= 560) scrollUp.classList.add("show-scroll")

    else scrollUp.classList.remove("show-scroll")
  })
  return (
    <a href="#" className="scrollup">
        <i className="ri-arrow-up-line scroll__icon"></i>
    </a>
  )
}

export default Scrollup